import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, Link } from '@material-ui/core/';
import { withStyles } from '@material-ui/core/styles';

import InsurancesViewModal from '../../../components/InsurancesViewModal';
import Avatar from '../../../components/Avatar';

function ProviderDetails(props) {
  const {
    provider,
    referPatientCallback,
    classes: {
      insuranceLink,
      root,
      image,
      logoImage,
      imagelessOutline,
      name,
      providerPractice,
      providerBio,
    },
  } = props;

  const {
    fullTitle: providerName,
    bio,
    practice = {},
    active,
    insurances,
  } = provider;
  const { name: practiceName } = practice;
  const [showModal, setModal] = useState(false);
  const onReferPatient = () => referPatientCallback(provider);

  return (
    <div className="zeroPadd">
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        className={root}
      >
        <Grid item xl={8} lg={8} sm={8} xs={12}>
          <Grid container alignItems="center">
            <Grid item lg={3} xs={12} sm={12} xl={12}>
              <Avatar
                providerId={provider.id}
                customStyles={{
                  width: '100px',
                  height: '100px',
                  marginLeft: '0px',
                }}
                className="providerAvatar"
              />
            </Grid>

            <Grid item lg={9} xs={12} sm={12} xl={12}>
              <Grid container direction="column">
                <Grid item xs={12}>
                  <h3 className={name}>
                    {provider.premium ? (
                      <img
                        src={process.env.PUBLIC_URL + '/favicon.ico'}
                        alt={providerName}
                        className={logoImage}
                      />
                    ) : (
                      ''
                    )}
                    {'  '}
                    {providerName}
                  </h3>
                </Grid>

                <Grid item xs={12}>
                  <span className={providerPractice}>{practiceName}</span>
                </Grid>

                <Grid item xs={12}>
                  <span className={providerBio}>{bio}</span>
                </Grid>

                <Grid item xs={12}>
                  {insurances.length > 0 && (
                    <Link
                      onClick={() => setModal(true)}
                      className={insuranceLink}
                    >
                      {`Accepts ${insurances.length} insurance(s)`}
                    </Link>
                  )}
                  {showModal && (
                    <InsurancesViewModal
                      open={showModal}
                      onClose={() => setModal(false)}
                      provider={provider}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xl={3} lg={3} sm={3} xs={12}>
          <Button color="primary" variant="contained" onClick={onReferPatient}>
            Doc to Doc appointment requests
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

const styles = () => ({
  root: {
    paddingBottom: '2rem',
  },
  image: {
    width: '100px',
    height: '100px',
    color: '#C2D1D9',
    marginBottom: '14px',
    borderRadius: '2px',
  },
  icon: {
    width: '20px',
    height: '20px',
    marginLeft: '5px',
  },
  logoImage: {
    width: '20px',
    height: '20px',
    marginRight: '5px',
  },
  imagelessOutline: {
    fontSize: '90px',
    color: '#C2D1D9',
    fontWeight: '300',
    marginBottom: '14px',
  },
  name: {
    fontSize: '1.5rem',
    lineHeight: '1.5rem',
    color: '#1C1C1C',
    fontWeight: 'normal',
    display: 'flex',
    flexWrap: 'wrap',
  },
  providerPractice: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: '#1C1C1C',
    fontWeight: 'normal',
  },
  providerBio: {
    fontSize: '0.8rem',
    lineHeight: '1rem',
    fontWeight: 'normal',
    color: '#A1AEB7',
  },
  insuranceLink: {
    fontSize: '0.9em',
    textDecoration: 'underline',
    '&:hover': {
      textDecoration: 'none',
      cursor: 'pointer',
    },

    color: 'black',
  },
});

ProviderDetails.propTypes = {
  provider: PropTypes.object,
  referPatientCallback: PropTypes.func,
};

export default withStyles(styles)(ProviderDetails);
